const QUESTION_SELECTED = 'QUESTION_SELECTED';
const THIRD_PARTY_BUNDLE_NAVIGATED = 'THIRD_PARTY_BUNDLE_NAVIGATED';

export { QUESTION_SELECTED, THIRD_PARTY_BUNDLE_NAVIGATED };
